import { render, staticRenderFns } from "./storelist1.vue?vue&type=template&id=fd532120&scoped=true&"
import script from "./storelist1.vue?vue&type=script&lang=js&"
export * from "./storelist1.vue?vue&type=script&lang=js&"
import style0 from "./storelist1.vue?vue&type=style&index=0&id=fd532120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd532120",
  null
  
)

export default component.exports